import { useState, useEffect } from "react";
import Chess from "chess.js";
import { Chessboard } from "react-chessboard";
import { Button } from "../components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "../components/ui/dialog";

export default function PlayRandomMoveEngine() {
    const [game, setGame] = useState(new Chess());
    const [history, setHistory] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [legalMoves, setLegalMoves] = useState({});

    useEffect(() => {
        setLegalMoves(game.moves({ verbose: true }).reduce((moves, move) => {
            if (!moves[move.from]) moves[move.from] = [];
            moves[move.from].push(move.to);
            return moves;
        }, {}));

        if (game.in_checkmate()) {
            setModalContent("Checkmate! Game Over.");
            setShowModal(true);
        } else if (game.in_stalemate()) {
            setModalContent("Stalemate! Game Over.");
            setShowModal(true);
        }
    }, [game]);

    function resetGame() {
        setGame(new Chess());
        setHistory([]);
    }

    function updateGame(move) {
        const updatedGame = new Chess(game.fen());
        if (updatedGame.move(move)) {
            setGame(updatedGame);
            setHistory(updatedGame.history({ verbose: true }));
        }
    }

    function onDrop(sourceSquare, targetSquare) {
        updateGame({
            from: sourceSquare,
            to: targetSquare,
            promotion: "q"
        });
    }

    function showFen() {
        setModalContent(game.fen());
        setShowModal(true);
    }

    function undoMove() {
        if (history.length > 0) {
            game.undo();
            setGame(new Chess(game.fen()));
            setHistory(game.history({ verbose: true }));
        }
    }

    return (
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 px-6 py-12">
            <p className="max-w-md text-center text-sm text-muted-foreground">
                This is a preview of the Chess project without user accounts. The full version
                has invitations and stores matches.
            </p>
            <Chessboard
                position={game.fen()}
                onPieceDrop={onDrop}
                boardWidth={400}
                customBoardStyle={{ borderRadius: '8px' }}
                customSquareStyles={{
                    ...Object.keys(legalMoves).reduce((styles, square) => ({
                        ...styles,
                        [square]: { backgroundColor: 'rgba(20, 184, 166, 0.35)' }
                    }), {})
                }}
            />
            <div className="flex flex-wrap justify-center gap-3">
                <Button onClick={resetGame}>Reset game</Button>
                <Button variant="outline" onClick={undoMove}>Undo move</Button>
                <Button variant="outline" onClick={showFen}>Show FEN</Button>
            </div>

            <Dialog open={showModal} onOpenChange={setShowModal}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Game status</DialogTitle>
                    </DialogHeader>
                    <p className="break-all font-mono text-sm">{modalContent}</p>
                </DialogContent>
            </Dialog>
        </div>
    );
}
